import React, { useState, useEffect } from 'react';
import {Form, Modal, notification, Input} from 'antd';
import Button from '/react4xp/mixins/ui/button/button';
import { IResultTypeModal } from '../express-help.types';
import {createResultType, updateResultType} from "/react4xp/parts/express-help/actions";

const ResultTypeModal = (props: IResultTypeModal) => {
  const [isSaving, setSaving] = useState(false);
  const { selectedObject, editMode } = props;

  const [form] = Form.useForm();

  const getFormTitle = (editMode: boolean) => {
    if (editMode) {
      return 'Редактирование типа результата';
    } else {
      return 'Создание типа результата';
    }
  };

  const onFinish = () => {
    form.validateFields().then(() => {
        const values = form.getFieldsValue();

      if (selectedObject || !editMode) {
        setSaving(true);

        if (editMode) {
            updateResultType(selectedObject.id, values)
            .then(() => {
              notification['success']({
                message: 'Данные обновлены!',
              });
              props.handleOk();
              form.resetFields();
            })
            .finally(() => setSaving(false));
        } else {
            createResultType(values)
            .then(() => {
              notification['success']({
                message: 'Тип результата создан!',
              });
              props.handleOk();
              form.resetFields();
            })
            .finally(() => setSaving(false));
        }
      }
    });
  };

  const handleCancel = () => {
    props.handleCancel();
    form.resetFields();
  };

  useEffect(() => {
    if (editMode) {
      form.setFieldsValue(selectedObject)
    }
  }, [selectedObject, form]);

  return (
    <Modal
      title={getFormTitle(editMode)}
      open={props.isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Отмена</Button>,
        <Button
          color="gold"
          type="primary"
          onClick={onFinish}
          loading={isSaving}
        >
          Сохранить
        </Button>,
      ]}
    >
      <div>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
        >
            <Form.Item
                name="resultTypeKk"
                label="Тип результата на казахском языке"
                rules={[
                    {
                        required: true,
                    },
                ]}
            >
                <Input placeholder="Введите" />
            </Form.Item>
            <Form.Item
                name="resultTypeRu"
                label="Тип результата на русском языке"
                rules={[
                    {
                        required: true,
                    },
                ]}
            >
                <Input placeholder="Введите" />
            </Form.Item>
            <Form.Item
                name="resultTypeEn"
                label="Тип результата на английском языке"
                rules={[
                    {
                        required: true,
                    },
                ]}
            >
                <Input placeholder="Введите" />
            </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default ResultTypeModal;
